const urlBaseMatoGrosso = '/v1/historicos-consulta-mato-grosso';
const urlBaseMatoGrossoSul = '/v1/historicos-consulta-mato-grosso-sul';
const urlBaseGoias = '/v1/historicos-consulta-goias';
const urlBaseMa = '/v1/historicos-consulta-maranhao';
const urlBaseTo = '/v1/historicos-consulta-tocantins';
const urlBasePara = '/v1/historicos-consulta-para';

export const formatarValor = (valor, precisao) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: precisao || 2,
  });

  return formatter.format(valor || 0);
};

export const switchHintOrigensDocumentos = seriesName => {
  switch (seriesName) {
    case 'Monitor A3':
      return 'Documentos obtidos através da manifestação via Monitor Box com certificado A3';
    case 'E-mail':
      return 'Documentos enviado através do provedor de email';
    case 'Upload Manual':
      return 'Documentos enviado através da opção de "Enviar Documentos" no Portal Tron Box';
    case 'Download Agente':
      return 'Robô que aciona o botão "Download do Documento" no Portal Nacional';
    case 'Agente Manifestação':
      return 'Robô que após manifesto do documento, obtém o XML completo via WebService da RFB';
    case 'Portal Estadual':
      return 'Robô que encontra o XML no Portal da SEFAZ Estadual';
    case 'Monitor Sincronização':
      return 'Documentos enviados por sincronização através do Monitor Box';
    default:
      return 'Origem Desconhecida';
  }
};

export const getUrlPortal = portalType => {
  switch (portalType) {
    case 1:
      return urlBaseMatoGrosso;
    case 2:
      return urlBaseMatoGrossoSul;
    case 3:
      return urlBaseGoias;
    case 4:
      return urlBaseMa;

    case 5:
      return urlBaseTo;
    case 6:
      return urlBasePara;
    default:
      return null;
  }
};
